import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Grid,
  Switch,
  MenuItem,
  Select,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import Avatar from "@material-ui/core/Avatar";
import { _getModuleDef } from "_module/utils/ModuleUtils";
import { _newModuleInstance } from "_module/utils/newModuleInstance";

export default class CfSharePermission extends Component {
  constructor(props) {
    super();
    this.state = {
      shUsers: [],
      shGroups: []
      // defaultPermission: "canDownloadNoLimit",
    };
  }

  componentDidMount() {
    const { addNewUsers, users, groups } = this.props;
    if(users && users.length){
      this.setState({shUsers: users});
    }

    if(groups && groups.length){
      this.setState({shGroups: groups});
    }
  }



  hanldeAddPermission = () => {
    const { addPermission, users, groups } = this.props;
    const {shGroups, shUsers } = this.state;

    let pUsers = shUsers;
    let pGroups = shGroups;


    addPermission(pUsers, pGroups);
  }


  handleValChangeUsers = (user,value) => {
    const {users} = this.props;
    const {shUsers } = this.state;
    let sUsers = shUsers;
    sUsers.find(e=> e.id == user.id).permission = value;
    this.setState({shUsers: sUsers})
  }
  handleValChangeGroups = (group,value) => {
    const {groups} = this.props;
    const {shGroups } = this.state;
    let sGroups = shGroups;
    sGroups.find(e=> e.id == group.id).permission = value;
    this.setState({shGroups: sGroups})
  }

  render() {
    const {
      open,
      close,
      DialogBoxTitle,
      DialogBoxContentText,
      addPermission,
      classes,
      users,
      groups,
      addNewUsers,
      orgRuntime:{
        runtime:{
          _mlCfSharePermissionOptions
        }
      }
    } = this.props;

    const {shGroups, shUsers } = this.state;

    return (
      <Dialog
        open={open}
        key={"shareCftPermission"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialogWrapper}
        class=" sharedUserPermissionModal"
      >
        <DialogTitle id="alert-dialog-title" className={classes.borderBottomHeader}>

          <div className={classes.modalContentTitle}>
            {DialogBoxTitle}
            <Button
              aria-label="Close set permission"
              className={clsx(
                classes.closeButton
              )}
              title="Close"
              onClick={() => {
                close();
              }}
            >
              <CloseIcon />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <p className={classes.shareClearanceForm}>
          You are about to share the clearance form with other MusicBox user(s). Please confirm the download permission type you would like to grant them.
          </p>
          <Grid className={classes.sharingBlock} container spacing={3}>         
            
                
                  {shUsers && shUsers.length > 0 && (
                    shUsers?.map((user,i) => {
                      return (
                        <>
                        <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>
                        {i=== 0 && <label>User(s)</label>}
                          <div  className={classes.sharedUserList}>
                            <Avatar
                              alt={user.name}
                              src={user.imageUrl}
                              className={classes.smallAvatar}
                            ></Avatar>
                            <div className={user.isExternal && !user.hasPermission ? classes.extUser : ""}>
                              <div title={user.name} className={classes.ListofUsers}>
                                {user.name}
                                <span title={user.email} className={classes.sharedUserListEmail}>{user.email}</span>
                                {/* {user.isExternal &&
                                <span title={user.orgName} className={clsx(classes.sharedUserListEmail, classes.sharedOrg)}>
                                  {user.orgName}
                                </span>} */}
                              </div>

                            </div>

                          </div>
                          </Grid>
                          <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>
                          {i=== 0 && <label>Permission(s)</label>}
                          <Select
                              className={clsx(
                                classes.globalSelectBox,
                                classes.sharedUserListItems
                              )}
                              fullWidth
                              onChange={(event)=>{
                                this.handleValChangeUsers(user,event.target.value)
                              }}
                              value={user.permission}
                              title="Select Permission"
                              variant="outlined"
                              name="selectPermissionUser"
                              inputProps={{
                                id: "SelectPermissionUser",
                                "aria-labelledby": "SelectPermissionUser",
                              }}
                            >
                              {_mlCfSharePermissionOptions.map((v) => (
                                <MenuItem
                                  key={v.id}
                                  className={classes.selectOptions}
                                  value={v.id}
                                >
                                  {v.name}
                                </MenuItem>
                              ))}
                          </Select>
                          </Grid>                      

                        </>
                      )
                    })
                  )}
                  {shGroups && shGroups.length > 0 && (
                    shGroups?.map((group,ii) => {
                      return (
                        <>
                          {ii=== 0 && <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>  <div className={classes.groupLabel}> <label>Group(s)</label></div></Grid>}

                          {ii=== 0 &&  <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>  <div className={classes.groupLabel}><div> {!users?.length  && <label>Permission(s)</label>}</div>   </div></Grid>} 
                      

                         <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>
                        
                          <div className={classes.sharedUserList}>
                            <Avatar
                              alt={group.name}
                              src={group.imageUrl}
                              className={classes.smallAvatar}
                            ></Avatar>
                            <div className={""}>
                              <div title={group.name} className={classes.ListofUsers}>
                                {group.name}
                              </div>
                              {/* {user.isExternal &&
                                <div title={user.orgName} className={clsx(classes.sharedUserListEmail, classes.sharedOrg)}>
                                  {user.orgName}
                                </div>} */}
                            </div>

                          </div>
                         
                          </Grid>
                            
                          {/* {!users?.length && <div className={classes.groupLabel}> {ii=== 0 && <label>Permission(s)</label>}</div>}         */}
                          <Grid item xs={12} sm={6} className={classes.paddingRemoveBottom}>
                                <div>

                                  <Select
                                    className={clsx(
                                      classes.globalSelectBox,
                                      classes.sharedUserListItems
                                    )}
                                    fullWidth
                                    onChange={(event)=>{
                                      this.handleValChangeGroups(group,event.target.value)
                                    }}
                                    value={group.permission}
                                    title="Select Permission"
                                    variant="outlined"
                                    name="selectPermissionGroup"
                                    inputProps={{
                                      id: "SelectPermissionGroups",
                                      "aria-labelledby": "SelectPermissionGroups",
                                    }}
                                  >
                                    {_mlCfSharePermissionOptions.map((v) => (
                                      <MenuItem
                                        key={v.id}
                                        className={classes.selectOptions}
                                        value={v.id}
                                      >
                                        {v.name}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                </div>                          
                          </Grid>
                        </>
                      )
                    })
                  )}            
                    
          </Grid>
        </DialogContent>
        <DialogActions className={classes.borderBottomFooter}>
          {addNewUsers && (
            <Button className={clsx(classes.globalCreateSaveButton)} onClick={this.hanldeAddPermission} color="primary" autoFocus>
              Add Permission
            </Button>
          )}
          {/* {!addNewUsers && (
            <Button className={clsx(classes.addUsersButton, classes.globalCreateSaveButton)} onClick={this.hanldeAddPermission} color="primary" autoFocus>
              Update Permission
            </Button>
          )} */}
          {/* <Button className={classes.dialogNoButton} onClick={close} color="primary">
            No
          </Button> */}

        </DialogActions>
      </Dialog>
    );
  }

}